export default {
    "/getWeChatJssdkSign": "/api/v1/wechat/jsSdkSign",
    "/sendPhoneCode": "/api/v2/customer/sendPhoneCode",
    "/findCompanyList": "/api/v2/customer/findCompanyList",
    "/signIn": "/api/v2/customer/signIn",
    "/getCaptcha": "/api/v1/agent/user/getCaptcha",

    "/getAgentArea": "/api/v1/agent/h5/findAreaList", // 获取代理区域列表
    "/getCompanyByName": "/api/v1/agent/h5/findCompanyList", // 根据公司名称查询公司列表
    "/getAgentLevel": "/api/v1/agent/h5/getCanRegisterAgentLevel", // 获取可注册的代理等级
    "/agentSignUp": "/api/v1/agent/h5/signUp", // 代理商注册
    "/getCaptchaH5": "/api/v1/agent/h5/getCaptcha",
    "/sendPhoneCodeH5": "/api/v1/agent/h5/sendPhoneCode",
    "/qrCodeScanLog": "/api/code/record/create", // 记录扫码
    "/getToken": "/api/v1/agent/user/auth", // 注册后登录
    "/getAgentByTaxCode": "/api/v1/agent/findByTaxCode", // 根据税号查询代理商（检查税号重复）
}


// WEBPACK FOOTER //
// ./src/utils/http/apis.js